import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { MAX_DOCUMENT_SIZE_LABEL } from '../constants/uploads'

export interface DocumentFilePickerButtonProps {
  file: File | null
  disabled?: boolean
  inputRef?: React.RefObject<HTMLInputElement | null>
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  emptyLabel?: string
  helperText?: string
  fullWidth?: boolean
  sx?: SxProps<Theme>
  accept?: string
}

export const DocumentFilePickerButton: React.FC<DocumentFilePickerButtonProps> = ({
  file,
  disabled,
  inputRef,
  onChange,
  emptyLabel = '📄 Upload Document (Optional)',
  helperText = `Supported: PDF (Max ${MAX_DOCUMENT_SIZE_LABEL})`,
  fullWidth = true,
  sx,
  accept = '.pdf,application/pdf',
}) => {
  return (
    <>
      <Button
        variant="outlined"
        component="label"
        disabled={disabled}
        fullWidth={fullWidth}
        sx={{
          height: 40,
          borderRadius: 1.5,
          px: 2,
          justifyContent: 'flex-start',
          border: '1px solid #ccc',
          color: 'text.secondary',
          fontSize: '14px',
          fontWeight: 'medium',
          width: '100%',
          minWidth: 0,
          ':hover': { color: 'text.primary', borderColor: 'text.primary', bgcolor: 'transparent' },
          ...sx,
        }}
      >
        <Box
          component="span"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            width: '100%',
            minWidth: 0,
            textAlign: 'left',
          }}
          title={file ? file.name : emptyLabel}
        >
          {file ? `📄 ${file.name}` : emptyLabel}
        </Box>
        <input
          ref={inputRef as any}
          type="file"
          hidden
          accept={accept}
          onChange={onChange}
        />
      </Button>
      {helperText ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5, display: 'block' }}>
          {helperText}
        </Typography>
      ) : null}
    </>
  )
}

export default DocumentFilePickerButton

